import React from 'react';
import styled from 'styled-components';

export const GDEBadge = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 600 213"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            width="599.62"
            height="213.12"
            x="0.38"
            y="-0.06"
            fill="none"
            rx="14.75"
            transform="rotate(180 300.19 106.5)"
          ></rect>
        </clipPath>
      </defs>
      <rect
        width="599.62"
        height="213.12"
        y="-0.06"
        fill="#fff"
        rx="14.75"
      ></rect>
      <path
        fill="#fff"
        d="M287 213.06H14.75A14.75 14.75 0 010 198.31V14.69A14.75 14.75 0 0114.75-.06h271.68"
      ></path>
      <path
        fill="#fff"
        d="M286.43-.06h298.44a14.76 14.76 0 0114.75 14.75v183.62a14.76 14.76 0 01-14.75 14.75H287"
      ></path>
      <path
        fill="#ea4335"
        d="M117.15 56.67l16.55-9.56A8.14 8.14 0 10125.55 33L97 49.52z"
      ></path>
      <path
        fill="#4285f4"
        d="M129.62 81.23A8.15 8.15 0 00133.7 66l-28.6-16.48a8.14 8.14 0 10-8.1 14.1l28.6 16.51a8.17 8.17 0 004.02 1.1z"
      ></path>
      <path
        fill="#fbbc04"
        d="M158.07 81.23a8.1 8.1 0 004.06-1.1l28.6-16.51-19.94-7.29L154 66a8.14 8.14 0 004.08 15.2z"
      ></path>
      <path
        fill="#089d57"
        d="M186.65 64.72a8.15 8.15 0 004.08-15.2L162.13 33A8.14 8.14 0 10154 47.11l28.59 16.51a8.17 8.17 0 004.06 1.1z"
      ></path>
      <g fill="#676d73">
        <path d="M63.31 94h20.8v4.07H67.53V110h15v4h-15v11.9h16.58v4.1h-20.8zM95.15 117l-8.89-12.6h4.83l6.62 9.49 6.38-9.49h5l-8.96 12.6 9.14 13h-5l-6.68-9.84-6.5 9.84h-5zM111.88 104.36h4.06v3.81h.21a9.27 9.27 0 013.49-3.29 10.44 10.44 0 015.24-1.33 11.52 11.52 0 016.23 1.76 12.19 12.19 0 014.42 4.87 16 16 0 010 14 12.27 12.27 0 01-4.42 4.85 11.51 11.51 0 01-6.23 1.75 10.34 10.34 0 01-5.24-1.33 9.24 9.24 0 01-3.49-3.24h-.21l.21 3.52v11.1h-4.27zm16.67 21.34a8.67 8.67 0 003.14-3.44 11.59 11.59 0 000-10.19 8.67 8.67 0 00-3.14-3.44 7.79 7.79 0 00-8.34 0 8.58 8.58 0 00-3.11 3.37 11.9 11.9 0 000 10.25 8.58 8.58 0 003.11 3.41 7.79 7.79 0 008.34 0zM145.93 129a12.22 12.22 0 01-4.55-4.85 14.65 14.65 0 01-1.63-7 15.31 15.31 0 011.53-6.83 12.46 12.46 0 014.34-5 11.57 11.57 0 016.53-1.86 12.33 12.33 0 016.53 1.69 11.13 11.13 0 014.24 4.64 15 15 0 011.49 6.78 5.08 5.08 0 01-.15 1.31H144a10.2 10.2 0 001.4 4.92 8.2 8.2 0 003.19 3 8.67 8.67 0 004 1 8.34 8.34 0 007.59-4.62l3.61 1.75a12.89 12.89 0 01-4.49 4.93 13.59 13.59 0 01-13.43.05zm14-14.57a8.28 8.28 0 00-.91-3.21 6.81 6.81 0 00-2.53-2.71 7.94 7.94 0 00-4.35-1.11 7.22 7.22 0 00-5.09 1.93 9.28 9.28 0 00-2.74 5.1zM168.37 104.76h4.07v4.07h.2a7 7 0 013.06-3.52 9.32 9.32 0 014.73-1.25 9.66 9.66 0 011.85.15v4.37a10.17 10.17 0 00-2.31-.2 7 7 0 00-5.29 2.15 7.87 7.87 0 00-2 5.63v14.21h-4.27zm26 25.5a6.49 6.49 0 01-2.23-1.38 6.29 6.29 0 01-1.51-2.25 8.65 8.65 0 01-.5-3.12v-15.29h-4.47v-3.86h4.47v-7.23h4.27v7.23h6.22v3.86h-6.22v14.27a5.15 5.15 0 00.8 3.19 3.43 3.43 0 002.76 1.13 5.19 5.19 0 002.81-.86v4.17a6.68 6.68 0 01-1.53.5 10.78 10.78 0 01-2 .15 8 8 0 01-2.88-.51zM207.34 128.84a10.55 10.55 0 01-3.91-5l3.81-1.7a7.67 7.67 0 002.84 3.56 7.31 7.31 0 004.14 1.26 8.18 8.18 0 004.12-1 3.14 3.14 0 00.35-5.38 12.54 12.54 0 00-4.27-1.68l-3.11-.8a11.19 11.19 0 01-5-2.56 6.47 6.47 0 01-.63-8.57 8.53 8.53 0 013.54-2.58 12.51 12.51 0 014.77-.91 12.2 12.2 0 016 1.46 8.2 8.2 0 013.74 4.07l-3.73 1.78q-1.71-3.42-6.08-3.42a6.92 6.92 0 00-3.69 1 2.88 2.88 0 00-1.58 2.49 2.79 2.79 0 001.1 2.28 8.77 8.77 0 003.32 1.43l3.71 1a12.16 12.16 0 015.68 2.83 6.24 6.24 0 011.91 4.6 6.62 6.62 0 01-1.36 4.14 8.67 8.67 0 01-3.66 2.74 13.43 13.43 0 01-5.13 1 11.71 11.71 0 01-6.88-2.04z"></path>
      </g>
      <path
        fill="#4285f4"
        d="M287.59 159.59H0v38.66A14.75 14.75 0 0014.75 213h272.93z"
      ></path>
      <text
        fill="#fff"
        fontFamily="GoogleSansDisplay-Regular, Google Sans Display"
        fontSize="33.17"
        transform="translate(107.2 198.28)"
      >
        2
        <tspan x="17.42" y="0" letterSpacing="-.01em">
          0
        </tspan>
        <tspan x="38.45" y="0">
          22
        </tspan>
      </text>
      <g clipPath="url(#clip-path)">
        <path
          fill="#e5efff"
          d="M287.22 -28.63H620.94V231.01999999999998H287.22z"
          transform="rotate(180 454.085 101.195)"
        ></path>
        <g
          fill="none"
          stroke="#a7cafd"
          strokeMiterlimit="10"
          strokeWidth="1.43"
          opacity="0.5"
        >
          <path d="M286.99 185.9L600.14 186.5"></path>
          <path d="M287.02 159.3L600.17 159.9"></path>
          <path d="M287.05 132.7L600.2 133.3"></path>
          <path d="M287.09 106.1L600.24 106.7"></path>
          <path d="M287.12 79.5L600.27 80.1"></path>
          <path d="M287.16 52.9L600.31 53.5"></path>
          <path d="M287.19 26.3L600.34 26.9"></path>
          <path d="M285.38 -0.3L600.37 0.3"></path>
          <path d="M313.78 -1.42L312.69 215.77"></path>
          <path d="M339.9 -1.39L338.81 215.81"></path>
          <path d="M366.02 -1.35L364.92 215.84"></path>
          <path d="M392.13 -1.32L391.04 215.87"></path>
          <path d="M418.25 -1.29L417.16 215.91"></path>
          <path d="M444.36 -1.25L443.27 215.94"></path>
          <path d="M470.48 -1.22L469.39 215.97"></path>
          <path d="M496.6 -1.19L495.5 216.01"></path>
          <path d="M522.71 -1.15L521.62 216.04"></path>
          <path d="M548.83 -1.12L547.74 216.08"></path>
          <path d="M574.94 -1.09L573.85 216.11"></path>
        </g>
      </g>
      <circle cx="444.17" cy="106.5" r="76.97" fill="#fff"></circle>
      <path
        fill="#212121"
        d="M584.87.19a14.52 14.52 0 0114.5 14.5v183.62a14.52 14.52 0 01-14.5 14.5H14.75a14.52 14.52 0 01-14.5-14.5V14.69A14.52 14.52 0 0114.75.19h570.12m0-.25H14.75A14.75 14.75 0 000 14.69v183.62a14.75 14.75 0 0014.75 14.75h570.12a14.76 14.76 0 0014.75-14.75V14.69A14.76 14.76 0 00584.87-.06z"
      ></path>
      <g>
        <path
          fill="#dd0031"
          d="M444.17 62.73L444.17 62.73 444.17 62.73 403.41 77.26 409.63 131.15 444.17 150.27 444.17 150.27 444.17 150.27 478.7 131.15 484.92 77.26 444.17 62.73z"
        ></path>
        <path
          fill="#c3002f"
          d="M444.17 62.73L444.17 72.44 444.17 72.4 444.17 116.74 444.17 116.74 444.17 150.27 444.17 150.27 478.7 131.15 484.92 77.26 444.17 62.73z"
        ></path>
        <path
          fill="#fff"
          d="M444.17 72.4l-25.48 57.12h9.5l5.12-12.78h21.63l5.12 12.78h9.5L444.17 72.4zm7.44 36.46h-14.88L444.17 91z"
        ></path>
      </g>
    </svg>
  );
};
